import { Heading } from '@madpaws/design-system';
import React from 'react';

import { DEFAULT_SERVICE_JOB, SERVICE_TYPE_BY_NAME_MAPPING } from '~/common/constants/search';

import styles from './DynamicPetSitterCount.module.css';

type Props = {
  isChronologyFine: boolean;
  serviceSlug: string;
  sittersCount: number;
};

export const DynamicPetSitterCount = ({
  serviceSlug,
  sittersCount,
  isChronologyFine,
}: Props): React.ReactElement | null => {
  /**
   * Since we have 100% adopted sniffer API,
   * We hide the sitter count if there are any search params filled
   * Basically we hide this for non SEO search pages
   */
  if (isChronologyFine) {
    return null;
  }

  const serviceJob = SERVICE_TYPE_BY_NAME_MAPPING[serviceSlug]?.serviceJob || DEFAULT_SERVICE_JOB;

  // get singular form if count less than 1
  const formattedServiceJob = sittersCount > 1 ? serviceJob : serviceJob.slice(0, -1);

  return (
    <div className={styles.root}>
      <Heading level={2}>{`${sittersCount} ${formattedServiceJob}`}</Heading>
    </div>
  );
};
